import { render, staticRenderFns } from "./CreateOffice.vue?vue&type=template&id=78f97561"
import script from "./CreateOffice.vue?vue&type=script&lang=js"
export * from "./CreateOffice.vue?vue&type=script&lang=js"
import style0 from "vue-search-select/dist/VueSearchSelect.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports